module.exports = __webpack_public_path__ + "static/img/qw_mob_02.71c46247.png";